define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaterAgreementApplicationService = void 0;
    class WaterAgreementApplicationService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("WaterAgreementApplication", httpProtocol, hostName, serviceName, proxyUrl);
        }
        calculateWaterAgreementFees(wa) {
            let p = {};
            p.wa = wa;
            return this.post("CalculateWaterAgreementFees", p, (json) => {
                return json;
            });
        }
        createAmendment(wa) {
            let p = {};
            p.wa = wa;
            return this.post("CreateAmendment", p, (json) => {
                return json;
            });
        }
        createWaterAgreementApplicationByParcel(agreementType, waParcel) {
            let p = {};
            p.agreementType = agreementType;
            p.waParcel = waParcel;
            return this.post("CreateWaterAgreementApplicationByParcel", p, (json) => {
                return json;
            });
        }
        createWaterAgreementApplicationByWf(agreementType, waterFacility) {
            let p = {};
            p.agreementType = agreementType;
            p.waterFacility = waterFacility;
            return this.post("CreateWaterAgreementApplicationByWf", p, (json) => {
                return json;
            });
        }
        generateAggregatedWaterAgreementReport(reportParameters) {
            let p = {};
            p.reportParameters = reportParameters;
            return this.post("GenerateAggregatedWaterAgreementReport", p, (json) => {
                return json;
            });
        }
        generateWaterAgreementReport(wa, waDocumentType) {
            let p = {};
            p.wa = wa;
            p.waDocumentType = waDocumentType;
            return this.post("GenerateWaterAgreementReport", p, (json) => {
                return json;
            });
        }
        getAggregatedWaterAgreementReport(reportFileId) {
            let p = {};
            p.reportFileId = reportFileId;
            return this.requestFile("GetAggregatedWaterAgreementReport", p);
        }
        getWaterAgreementDocument(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetWaterAgreementDocument", p);
        }
        getWaterAgreementFeeRuleFiscalYears() {
            let p = {};
            return this.post("GetWaterAgreementFeeRuleFiscalYears", p, (json) => {
                return json;
            });
        }
        getWaterFacilityEquipmentTypes() {
            let p = {};
            return this.post("GetWaterFacilityEquipmentTypes", p, (json) => {
                return json;
            });
        }
        persistWaterAgreementApplication(application) {
            let p = {};
            p.application = application;
            return this.post("PersistWaterAgreementApplication", p, (json) => {
                return json;
            });
        }
        persistWaterAgreementFiscalYearFeeRule(fyFeeRule) {
            let p = {};
            p.fyFeeRule = fyFeeRule;
            return this.post("PersistWaterAgreementFiscalYearFeeRule", p, (json) => {
                return json;
            });
        }
        readWaterAgreementApplication(applicationId) {
            let p = {};
            p.applicationId = applicationId;
            return this.post("ReadWaterAgreementApplication", p, (json) => {
                return json;
            });
        }
        readWaterAgreementApplicationByAgreementId(id) {
            let p = {};
            p.id = id;
            return this.post("ReadWaterAgreementApplicationByAgreementId", p, (json) => {
                return json;
            });
        }
        readWaterAgreementFiscalYearFeeRule(fiscalYear) {
            let p = {};
            p.fiscalYear = fiscalYear;
            return this.post("ReadWaterAgreementFiscalYearFeeRule", p, (json) => {
                return json;
            });
        }
        renewWaterAgreementsFees(fiscalYear, lgaCode) {
            let p = {};
            p.fiscalYear = fiscalYear;
            p.lgaCode = lgaCode;
            return this.post("RenewWaterAgreementsFees", p, (json) => {
                return json;
            });
        }
        updateWaterAgreementFiscalYearFeeRule(fyFeeRule, isAnnualIncreaseChanged) {
            let p = {};
            p.fyFeeRule = fyFeeRule;
            p.isAnnualIncreaseChanged = isAnnualIncreaseChanged;
            return this.post("UpdateWaterAgreementFiscalYearFeeRule", p, (json) => {
                return json;
            });
        }
        updateWaterAgreementOnDateChange(wa) {
            let p = {};
            p.wa = wa;
            return this.post("UpdateWaterAgreementOnDateChange", p, (json) => {
                return json;
            });
        }
        updateWaterAgreementOnGeometryChange(wa) {
            let p = {};
            p.wa = wa;
            return this.post("UpdateWaterAgreementOnGeometryChange", p, (json) => {
                return json;
            });
        }
        updateWaterAgreementOnWaterFacilityReselection(wa, wfId) {
            let p = {};
            p.wa = wa;
            p.wfId = wfId;
            return this.post("UpdateWaterAgreementOnWaterFacilityReselection", p, (json) => {
                return json;
            });
        }
        uploadWaterAgreementDocument(waId, waDocumentType, documentName, base64Document) {
            let p = {};
            p.waId = waId;
            p.waDocumentType = waDocumentType;
            p.documentName = documentName;
            p.base64Document = base64Document;
            return this.post("UploadWaterAgreementDocument", p, (json) => {
                return json;
            });
        }
        validateWaterAgreement(wa) {
            let p = {};
            p.wa = wa;
            return this.post("ValidateWaterAgreement", p, (json) => {
                return json;
            });
        }
        validateWaterAgreementApplication(application) {
            let p = {};
            p.application = application;
            return this.post("ValidateWaterAgreementApplication", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.WaterAgreementApplicationService = WaterAgreementApplicationService;
});
